import React, { useEffect, useState } from 'react';
import ImgUltra from 'assets/images/icon/icon-ultra.png';
import ImgTeam from 'assets/images/icon/icon-teamviewer.png';

import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';
import { urlApi } from 'constants/urlApi';
import queryString from 'query-string';
import Axios from 'axios';
import { useApp } from 'context/AppContext';
import { loading } from 'helpers/loading/Loading';
import { notification } from 'constants/notification';
import clientApi from 'api/clientApi';
import { useSelector } from 'react-redux';
import { selectAuth } from 'app/slice/authSlice';
import { APP_ECONTRACT } from 'constants/global';
import { useQuery } from '@tanstack/react-query';
import configApi from 'api/configApi';
import { ACTIVE_STATUS } from 'constants/status';
import MENU_CONFIG from 'constants/menuConfig';
import { RequestSupportDialog } from 'features/request-support/components/RequestSupportDialog';
import configClientApi from 'api/client/configClientApi';

const AppFooter = () => {
    const windowEnvConfig = window['runConfig'];
    const intl = useIntl();
    const { showAlert } = useApp();
    const authData = useSelector(selectAuth);

    const AppName = authData?.app === APP_ECONTRACT ? 'xCyber Contract' : 'xCyber Doc';
    const versionApp =
        authData?.app === APP_ECONTRACT
            ? windowEnvConfig.REACT_APP_VERSION_CONTRACT
            : windowEnvConfig.REACT_APP_VERSION;

    const [listMenuConfig, setListMenuConfig] = useState([]);

    const resultMenuConfig = useQuery(['configApi-getAllMenuConfig'], async () => {
        return await configClientApi.getAllMenuConfig({ status: ACTIVE_STATUS });
    });

    const genDataMenuConfig = () => {
        try {
            if (resultMenuConfig.data) {
                const { data, status, message } = resultMenuConfig.data;
                if (status === 2) {
                    showAlert('error', notification.FAIL, message);
                    return;
                }
                if (status === 1) {
                    let arr = [];
                    data.forEach((element) => {
                        arr.push(element.name);
                    });
                    setListMenuConfig(arr);
                }
            }
        } catch (error) {
            console.error('error: ', error);
        }
    };
    useEffect(() => {
        genDataMenuConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultMenuConfig.data, resultMenuConfig.isFetching]);

    const downloadFile = async (e, type) => {
        loading.runLoadingBlockUI();
        try {
            const BASE_URL = windowEnvConfig.REACT_APP_BASE_API_URL;
            let contentIframe = `${BASE_URL}${urlApi.URL_DOWNLOAD}?`;
            let stringApiIframe = {
                type,
            };

            const result = await clientApi.infoFileSoftware(stringApiIframe);
            if (result.status === 2) {
                showAlert('error', notification.FAIL, result.message);
                return;
            }

            const querryIframe = queryString.stringify(stringApiIframe);
            contentIframe += querryIframe;
            const url = contentIframe;

            Axios.get(`${url}`, {
                responseType: 'blob',
            })
                .then(function (response) {
                    const urlDownload = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = urlDownload;
                    link.download = result.data.file_name;
                    document.body.appendChild(link);
                    link.click();
                    loading.stopRunLoading();
                })
                .catch(function (error) {
                    loading.stopRunLoading();
                    console.error('error: ', error);
                    showAlert('error', notification.FAIL, notification.MESSAGE_ERROR);
                });
        } catch (error) {
            loading.stopRunLoading();
            console.error('error: ', error);
            showAlert('error', notification.FAIL, notification.MESSAGE_ERROR);
        }
    };

    const [visibleRequestSupport, setVisibleRequestSupport] = useState(false);
    const onHideDialogRequestSupport = () => {
        setVisibleRequestSupport(false);
    };

    return (
        <div className="layout-footer p-d-flex p-flex-wrap text-fw-600">
            <div className="layout-footer-left p-d-flex p-flex-wrap">
                <div className="p-mr-2 p-mb-2">
                    <span onClick={(e) => downloadFile(e, 3)} className="pointer">
                        <img
                            src={ImgUltra}
                            alt="icon-ultra-viewer"
                            width="16"
                            height="auto"
                            className="p-mr-2 align-middle"
                            loading="lazy"
                        />
                        UltraViewer
                    </span>
                </div>
                <div className="p-mr-2 p-mb-2">
                    <span onClick={(e) => downloadFile(e, 2)} className="pointer">
                        <img
                            src={ImgTeam}
                            alt="icon-team-viewer"
                            width="17"
                            height="auto"
                            className="p-mr-2 align-middle"
                            loading="lazy"
                        />
                        TeamViewer
                    </span>
                </div>
                <div className="p-mr-2 p-mb-2">
                    <span onClick={(e) => downloadFile(e, 1)} className="pointer">
                        <span className="pi pi-fw pi-cloud-download p-mr-2 align-middle"></span>
                        <span className="align-middle">{intl.formatMessage({ id: 'common.downCyberSignClient' })}</span>
                    </span>
                </div>
                {listMenuConfig.includes(MENU_CONFIG.CRM_REQUEST_SUPPORT) && (
                    <div className="p-mb-2 pointer" onClick={() => setVisibleRequestSupport(true)}>
                        <span className="pi pi-question p-mr-2 align-middle"></span>
                        <span className="align-middle">{intl.formatMessage({ id: 'common.requestSupport' })}</span>
                    </div>
                )}
            </div>
            <div className="layout-footer-right p-d-flex p-flex-wrap">
                <div className="p-mr-2 p-mb-2">
                    ©{' '}
                    <a href="https://cyberlotus.com" target="_blank" rel="noopener noreferrer">
                        CyberLotus
                    </a>{' '}
                    - {AppName}
                </div>
                <div className="p-mb-2">
                    <FormattedMessage id="version" defaultMessage="Phiên bản" /> {versionApp}
                </div>
            </div>
            {visibleRequestSupport && (
                <RequestSupportDialog visible={visibleRequestSupport} onHideDialog={onHideDialogRequestSupport} />
            )}
        </div>
    );
};

export default AppFooter;
